import React, { useState, useEffect, useCallback, useRef } from 'react';
import './AdminRecursos.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

/* ── Icons ── */
const IconPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconTrash    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconFilter   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconStar     = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="13" height="13"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCart     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="9" cy="21" r="1" stroke="currentColor" strokeWidth="2"/><circle cx="20" cy="21" r="1" stroke="currentColor" strokeWidth="2"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconPdf      = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M9 13h1.5a1.5 1.5 0 010 3H9v-3zM9 16v2M15 13v5M13 15.5h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>);
const IconKit      = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="12" x2="12" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="10" y1="14" x2="14" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconGame     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="6" width="20" height="12" rx="4" stroke="currentColor" strokeWidth="2"/><path d="M6 12h4M8 10v4M15 11h2M15 13h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconDollar   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTag      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="7" y1="7" x2="7.01" y2="7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconGrid     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2"/><rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2"/><rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2"/><rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2"/></svg>);
const IconList     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><line x1="8" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="8" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="8" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="3" y1="6" x2="3.01" y2="6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="3" y1="12" x2="3.01" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="3" y1="18" x2="3.01" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconFile     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6M9 13h6M9 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUpload   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconLink     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

/* ── Constantes ── */
const CATEGORIAS = ['Lenguaje','Habla','TEA','Aprendizaje','Familia','Tartamudez','Gratuito'];
const TIPOS      = ['recurso','kit','juego'];
const NIVELES    = ['Básico','Intermedio','Avanzado','Profesional','Terapeuta / Familia','Familia'];
const FORMATOS   = ['PDF','PDF imprimible','PDF + Imágenes','PDF + Word editable','PDF editable','PDF + PNG','Video','ZIP'];
const COLORES    = ['verde','azul','amarillo','rosa','morado'];
const TIPO_ICON  = { recurso:<IconPdf/>, kit:<IconKit/>, juego:<IconGame/> };
//const TIPO_LABEL = { recurso:'Recurso', kit:'Kit', juego:'Juego' };
const TIPO_LABEL = { recurso:'Imprimible', kit:'Cuadernillo', juego:'Juego' };

const CAT_COLOR  = { Lenguaje:'verde', TEA:'azul', Habla:'amarillo', Tartamudez:'rosa', Aprendizaje:'morado', Familia:'rosa' };

const FORM_EMPTY = {
  id:null, tipo:'recurso', categoria:'Lenguaje', color:'verde',
  titulo:'', descripcion:'', descripcion_larga:'', formato:'PDF',
  paginas:'', nivel:'Básico', precio:'', precio_antes:'',
  badge:'', tags:'', imagen_url:'', destacado:false, activo:true,
  tipo_acceso:'archivo',
  archivo_url:'', archivo_nombre:'', link_externo:'',
  seccion:'normal', fecha_evento:'', archivos:[], codigo_sunat:'', imagenes:[],
  
  video_url:'', codigo:'', edad_minima:'',
  jugadores_min:'', jugadores_max:'', duracion_min:'', duracion_max:'',
  es_fisico:false, stock:'', dias_entrega:'',
};

function kpi(recursos) {
  const activos    = recursos.filter(r=>r.activo).length;
  const ventas     = recursos.reduce((s,r)=>s+(r.ventas||0),0);
  const ingresos   = recursos.reduce((s,r)=>s+(r.ventas||0)*(r.precio||0),0);
  const destacados = recursos.filter(r=>r.destacado).length;
  return { activos, ventas, ingresos, destacados, total:recursos.length };
}

/* ════════════════════════════════════════ */
export default function AdminRecursos() {
  const [recursos,   setRecursos]   = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [busqueda,   setBusqueda]   = useState('');
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [filtroCat,  setFiltroCat]  = useState('todas');
  const [filtroEst,  setFiltroEst]  = useState('todos');
  const [filtroSec,  setFiltroSec]  = useState('todos');
  const [vista,      setVista]      = useState('tabla');
  const [modal,      setModal]      = useState(null);
  const [selected,   setSelected]   = useState(null);
  const [form,       setForm]       = useState(FORM_EMPTY);
  const [guardando,  setGuardando]  = useState(false);
  const [subiendo,   setSubiendo]   = useState(false);
  const [progresoSub,setProgresoSub]= useState(0);
  const [toast,      setToast]      = useState(null);
  const fileRef = useRef();
  const imgRef        = useRef();
  const imgMockupRef  = useRef();
  const [subiendoImg,     setSubiendoImg]     = useState(false);
  const [subiendoMockup,  setSubiendoMockup]  = useState(false);
  

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3000); };
  const setF = (k,v) => setForm(f=>({...f,[k]:v}));

  /* ── Fetch recursos desde BD ── */
  const fetchRecursos = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=admin_list`);
      const j = await r.json();
      if (j.success) setRecursos(j.data || []);
      else showToast(j.message || 'Error cargando recursos','error');
    } catch(e) { showToast('Error de conexión','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchRecursos(); }, [fetchRecursos]);

  /* ── Filtrar ── */
  const filtrados = recursos.filter(r => {
    const q = busqueda.toLowerCase();
    const mQ = !q || r.titulo?.toLowerCase().includes(q) || (Array.isArray(r.tags)?r.tags:r.tags||[]).join?.(' ').includes(q) || r.categoria?.toLowerCase().includes(q);
    const mT = filtroTipo==='todos' || r.tipo===filtroTipo;
    const mC = filtroCat==='todas'  || r.categoria===filtroCat;
    const mE = filtroEst==='todos'  || (filtroEst==='activo'?r.activo:!r.activo);
    const mS = filtroSec==='todos'  || (r.tipo===filtroSec);
    return mQ && mT && mC && mE && mS;
  });

  /* ── Abrir modales ── */
  const abrirNuevo  = () => { setForm(FORM_EMPTY); setModal('nuevo'); };
  const abrirEditar = r  => {
    
    
    setForm({
      ...r,
      tags: Array.isArray(r.tags) ? r.tags.join(', ') : (r.tags||''),
      precio_antes: r.precio_antes ?? '',
      descripcion_larga: r.descripcion_larga ?? '',
      seccion: r.seccion || 'normal',
      fecha_evento: r.fecha_evento || '',
      archivos: r.archivos || [],
      codigo_sunat: r.codigo_sunat || '',
      imagenes:     r.imagenes     || [],
      video_url:     r.video_url     || '',
      codigo:        r.codigo        || '',
      edad_minima:   r.edad_minima   ?? '',
      jugadores_min: r.jugadores_min ?? '',
      jugadores_max: r.jugadores_max ?? '',
     
      duracion_min:  r.duracion_min  ?? '',
      duracion_max:  r.duracion_max  ?? '',
      es_fisico:     !!r.es_fisico,
      stock:         r.stock         ?? '',
      dias_entrega:  r.dias_entrega  || '',
    });


    setSelected(r); setModal('editar');
  };
  const abrirVer    = r  => { setSelected(r); setModal('ver'); };
  const abrirBorrar = r  => { setSelected(r); setModal('borrar'); };
  const cerrar      = () => { setModal(null); setSelected(null); };

  /* ── Guardar (crear o editar) ── */
  const guardar = async () => {
    if (!form.titulo.trim()) { showToast('El título es obligatorio','error'); return; }
    if (!form.precio || parseFloat(form.precio)<=0) { showToast('El precio debe ser mayor a 0','error'); return; }

    setGuardando(true);
    const action = modal==='nuevo' ? 'crear_recurso' : 'editar_recurso';
    const tagsArr = typeof form.tags==='string'
      ? form.tags.split(',').map(t=>t.trim()).filter(Boolean)
      : (form.tags||[]);

    try {
      const r = await fetch(`${API}?action=${action}`, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ ...form, tags: tagsArr }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(modal==='nuevo' ? 'Recurso creado' : 'Recurso actualizado');
      cerrar();
      fetchRecursos();
    } catch(err) { showToast(err.message,'error'); }
    finally { setGuardando(false); }
  };

  /* ── Borrar ── */
  const borrar = async () => {
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=eliminar_recurso`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: selected.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Recurso eliminado');
      fetchRecursos();
      cerrar();
    } catch(err) { showToast(err.message,'error'); }
    finally { setGuardando(false); }
  };

  /* ── Toggles optimistas ── */
  const toggleEstado = async (id) => {
    setRecursos(rs=>rs.map(r=>r.id===id?{...r,activo:!r.activo}:r));
    try {
      await fetch(`${API}?action=toggle_activo`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id})});
    } catch(e) { fetchRecursos(); } // revertir si falla
  };
  const toggleDestacado = async (id) => {
    setRecursos(rs=>rs.map(r=>r.id===id?{...r,destacado:!r.destacado}:r));
    try {
      await fetch(`${API}?action=toggle_destacado`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id})});
    } catch(e) { fetchRecursos(); }
  };

  /* ── Subir archivo ── */
  const subirArchivo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!form.id) { showToast('Guarda el recurso primero','error'); return; }

    const fd = new FormData();
    fd.append('archivo', file);
    fd.append('recurso_id', form.id);

    setSubiendo(true); setProgresoSub(0);
    const interval = setInterval(()=>setProgresoSub(p=>Math.min(p+12,85)),300);

    try {
      const r = await fetch(`${API}?action=subir_archivo_multi`, { method:'POST', body:fd });
      clearInterval(interval); setProgresoSub(100);
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      // Agregar a la lista de archivos
      setF('archivos', [...(form.archivos||[]), j.data]);
      showToast('Archivo subido correctamente');
    } catch(err) {
      clearInterval(interval);
      showToast(err.message||'Error al subir archivo','error');
    } finally {
      setSubiendo(false); setProgresoSub(0);
      if (fileRef.current) fileRef.current.value='';
    }
  };

  /* ── Subir imagen de portada ── */
  const subirImagen = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { showToast('La imagen excede 10MB', 'error'); return; }
    const fd = new FormData();
    fd.append('imagen', file);
    if (form.id) fd.append('recurso_id', form.id);
    setSubiendoImg(true);
    try {
      const r = await fetch(`${API}?action=subir_imagen`, { method:'POST', body:fd });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setF('imagen_url', j.data.imagen_url);
      showToast('Imagen subida correctamente');
    } catch(err) {
      showToast(err.message || 'Error al subir imagen', 'error');
    } finally {
      setSubiendoImg(false);
      if (imgRef.current) imgRef.current.value = '';
    }
  };

 /* ── Subir imagen mockup ── */
 const subirMockup = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;
  if (!form.id) { showToast('Guarda el recurso primero', 'error'); return; }
  if (file.size > 10 * 1024 * 1024) { showToast('Imagen excede 10MB', 'error'); return; }
  const fd = new FormData();
  fd.append('imagen', file);
  fd.append('recurso_id', form.id);
  setSubiendoMockup(true);
  try {
    const r = await fetch(`${API}?action=subir_imagen_mockup`, { method:'POST', body:fd });
    const j = await r.json();
    if (!j.success) throw new Error(j.message);
    setF('imagenes', [...(form.imagenes||[]), j.data]);
    showToast('Mockup subido');
  } catch(err) {
    showToast(err.message || 'Error al subir mockup', 'error');
  } finally {
    setSubiendoMockup(false);
    if (imgMockupRef.current) imgMockupRef.current.value = '';
  }
};

const stats = kpi(recursos);

  return (
    <div className="ar-page">

      {toast && (
        <div className={`ar-toast ar-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* ── HEADER ── */}
      <div className="ar-header">
        <div>
          <h1>Recursos</h1>
          <p>Gestiona PDFs, kits y juegos del catálogo</p>
        </div>
        <div style={{display:'flex',gap:'.6rem'}}>
          <button className="ar-btn-ghost" onClick={fetchRecursos}><IconRefresh/> Sincronizar</button>
          <button className="ar-btn-primary" onClick={abrirNuevo}><IconPlus/> Nuevo recurso</button>
        </div>
      </div>

      {/* ── KPIs ── */}
      <div className="ar-kpis">
        <div className="ar-kpi"><p>Total recursos</p><strong>{loading?'…':stats.total}</strong><span>{stats.activos} activos</span></div>
        <div className="ar-kpi ar-kpi--verde"><p>Ventas acumuladas</p><strong>{loading?'…':stats.ventas.toLocaleString()}</strong><span>Unidades vendidas</span></div>
        <div className="ar-kpi"><p>Ingresos estimados</p><strong>S/. {loading?'…':stats.ingresos.toLocaleString()}</strong><span>Precio × ventas</span></div>
        <div className="ar-kpi"><p>Destacados</p><strong>{loading?'…':stats.destacados}</strong><span>En portada</span></div>
      </div>

      {/* ── FILTROS ── */}
      <div className="ar-filtros">
        <div className="ar-search">
          <IconSearch/>
          <input type="text" placeholder="Buscar por título, categoría, etiqueta…"
            value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
          {busqueda && <button className="ar-search__clear" onClick={()=>setBusqueda('')}><IconClose/></button>}
        </div>
        <div className="ar-filtros__selects">
          <div className="ar-select-wrap"><IconFilter/>
            <select className="ar-select" value={filtroTipo} onChange={e=>setFiltroTipo(e.target.value)}>
              <option value="todos">Todos los tipos</option>
              {TIPOS.map(t=><option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
            </select>
          </div>
          <select className="ar-select ar-select--pill" value={filtroCat} onChange={e=>setFiltroCat(e.target.value)}>
            <option value="todas">Todas las categorías</option>
            {CATEGORIAS.map(c=><option key={c}>{c}</option>)}
          </select>
          <select className="ar-select ar-select--pill" value={filtroEst} onChange={e=>setFiltroEst(e.target.value)}>
            <option value="todos">Todos los estados</option>
            <option value="activo">Activo</option>
            <option value="inactivo">Inactivo</option>
          </select>
          <select className="ar-select ar-select--pill" value={filtroSec} onChange={e=>setFiltroSec(e.target.value)}>
            <option value="todos">Todas las secciones</option>
            <option value="recurso">📄 Imprimibles</option>
            <option value="kit">📦 Cuadernillos</option>
            <option value="juego">🎮 Juegos</option>
          </select>
        </div>
        <span className="ar-count">{loading?'…':filtrados.length} resultado{filtrados.length!==1?'s':''}</span>
        <div className="ar-vista-toggle">
          <button className={`ar-vista-btn ${vista==='tabla'?'ar-vista-btn--active':''}`} onClick={()=>setVista('tabla')} title="Vista tabla"><IconList/></button>
          <button className={`ar-vista-btn ${vista==='grid'?'ar-vista-btn--active':''}`} onClick={()=>setVista('grid')} title="Vista tarjetas"><IconGrid/></button>
        </div>
      </div>

      {/* ════════════════════════════════
          VISTA TABLA
      ════════════════════════════════ */}
      {vista==='tabla' && (
        <div className="ar-tabla-wrap">
          <table className="ar-tabla">
            <thead>
            <tr>
                <th>Recurso</th><th>Tipo/Sección</th><th>Categoría</th>
                <th>Acceso</th><th>Precio</th><th>Ventas</th>
                <th>Destacado</th><th>Estado</th><th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="9" className="ar-tabla__empty">Cargando recursos…</td></tr>
              ) : filtrados.length===0 ? (
                <tr><td colSpan="9" className="ar-tabla__empty">No hay recursos con ese criterio</td></tr>
              ) : filtrados.map(r=>(
                <tr key={r.id} className="ar-tabla__row">
                  <td className="ar-td-main">
                    <div className={`ar-thumb ar-thumb--${r.color||'verde'}`}>{TIPO_ICON[r.tipo]}</div>
                    <div>
                      <p className="ar-td-titulo">{r.titulo}</p>
                      <p className="ar-td-nivel">{r.nivel} · {r.paginas ? `${r.paginas} págs.` : r.formato}</p>
                      {r.rating>0 && <span className="ar-rating"><IconStar/>{r.rating}</span>}
                      {r.badge && <span className="ar-badge-mini">{r.badge}</span>}
                    </div>
                  </td>
                  
                  
                  <td>
                    <span className={`ar-badge ar-badge--tipo ar-badge--${r.tipo}`}>{TIPO_ICON[r.tipo]}{TIPO_LABEL[r.tipo]}</span>
                    <br/>
                    {r.tipo==='recurso'
                      ? <span style={{fontSize:'.68rem',color:'#5a6a63'}}>📄 Imprimible</span>
                      : r.tipo==='kit'
                      ? <span style={{fontSize:'.68rem',color:'#5a6a63'}}>📦 Cuadernillo</span>
                      : <span style={{fontSize:'.68rem',color:'#5a6a63'}}>🎮 Juego</span>
                    }
                  </td>

                  <td><span className={`ar-badge ar-badge--cat ar-badge--${CAT_COLOR[r.categoria]||'verde'}`}>{r.categoria}</span></td>
                  <td>
                    <span className={`ar-acceso-badge ar-acceso-badge--${r.tipo_acceso}`}>
                      {r.tipo_acceso==='archivo' ? <><IconFile/> Archivo</> :
                       r.tipo_acceso==='link_externo' ? <><IconLink/> Link externo</> :
                       <><IconKit/> Kit</>}
                    </span>
                    {r.archivo_url && <p className="ar-td-archivo" title={r.archivo_nombre}>{r.archivo_nombre?.slice(0,20)}{r.archivo_nombre?.length>20?'…':''}</p>}
                    {r.link_externo && <p className="ar-td-archivo" title={r.link_externo}>Link configurado</p>}
                  </td>
                  <td>
                    <div className="ar-precio-col">
                      <span className="ar-precio-main"><IconDollar/>S/. {parseFloat(r.precio||0).toFixed(2)}</span>
                      {r.precio_antes && <span className="ar-precio-antes">S/. {parseFloat(r.precio_antes).toFixed(2)}</span>}
                    </div>
                  </td>
                  <td><span className="ar-ventas"><IconCart/>{r.ventas||0}</span></td>
                  <td>
                    <button className={`ar-toggle-dest ${r.destacado?'ar-toggle-dest--on':''}`} onClick={()=>toggleDestacado(r.id)}>
                      <IconStar/> {r.destacado?'Sí':'No'}
                    </button>
                  </td>
                  <td>
                    <button className={`ar-estado ar-estado--${r.activo?'activo':'inactivo'}`} onClick={()=>toggleEstado(r.id)}>
                      {r.activo?'Activo':'Inactivo'}
                    </button>
                  </td>
                  <td>
                    <div className="ar-acciones">
                      <button className="ar-accion ar-accion--ver"    onClick={()=>abrirVer(r)}    title="Ver"><IconEye/></button>
                      <button className="ar-accion ar-accion--editar" onClick={()=>abrirEditar(r)} title="Editar"><IconEdit/></button>
                      <button className="ar-accion ar-accion--borrar" onClick={()=>abrirBorrar(r)} title="Eliminar"><IconTrash/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ════════════════════════════════
          VISTA GRID
      ════════════════════════════════ */}
      {vista==='grid' && (
        <div className="ar-grid">
          {loading ? (
            <div className="ar-grid__empty">Cargando recursos…</div>
          ) : filtrados.length===0 ? (
            <div className="ar-grid__empty">No hay recursos con ese criterio</div>
          ) : filtrados.map(r=>(
            <div key={r.id} className="ar-card">
              <div className={`ar-card__thumb ar-thumb--${r.color||'verde'}`}>
                <div className="ar-card__thumb-icon">{TIPO_ICON[r.tipo]}</div>
                {r.badge && <span className="ar-card__badge-top">{r.badge}</span>}
                {r.destacado && <span className="ar-card__dest"><IconStar/>Destacado</span>}
                <span className={`ar-card__acceso ar-acceso-badge--${r.tipo_acceso}`}>
                  {r.tipo_acceso==='archivo'?'📄 Archivo':r.tipo_acceso==='link_externo'?'🔗 Link':'📦 Kit'}
                </span>
              </div>
              <div className="ar-card__body">
                <div className="ar-card__meta">
                  <span className={`ar-badge ar-badge--cat ar-badge--${CAT_COLOR[r.categoria]||'verde'}`}>{r.categoria}</span>
                  <span className={`ar-badge ar-badge--tipo ar-badge--${r.tipo}`}>{TIPO_LABEL[r.tipo]}</span>
                </div>
                <h4 className="ar-card__titulo">{r.titulo}</h4>
                <p className="ar-card__desc">{r.descripcion}</p>
                <div className="ar-card__info">
                  <span><IconFile/>{r.formato}</span>
                  {r.paginas && <span>{r.paginas} págs.</span>}
                  {r.rating>0 && <span><IconStar/>{r.rating}</span>}
                </div>
                <div className="ar-card__footer">
                  <div className="ar-card__precio">
                    <strong>S/. {parseFloat(r.precio||0).toFixed(2)}</strong>
                    {r.precio_antes && <s>S/. {parseFloat(r.precio_antes).toFixed(2)}</s>}
                  </div>
                  <span className="ar-card__ventas"><IconCart/>{r.ventas||0} ventas</span>
                </div>
              </div>
              <div className="ar-card__actions">
                <button className={`ar-estado ar-estado--${r.activo?'activo':'inactivo'}`} onClick={()=>toggleEstado(r.id)}>
                  {r.activo?'Activo':'Inactivo'}
                </button>
                <div className="ar-acciones">
                  <button className="ar-accion ar-accion--ver"    onClick={()=>abrirVer(r)}><IconEye/></button>
                  <button className="ar-accion ar-accion--editar" onClick={()=>abrirEditar(r)}><IconEdit/></button>
                  <button className="ar-accion ar-accion--borrar" onClick={()=>abrirBorrar(r)}><IconTrash/></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ════════════════════════════════
          MODAL NUEVO / EDITAR
      ════════════════════════════════ */}
      {(modal==='nuevo'||modal==='editar') && (
        <div className="ar-overlay" onClick={cerrar}>
          <div className="ar-modal ar-modal--form" onClick={e=>e.stopPropagation()}>
            <div className="ar-modal__head">
              <div>
                <h2>{modal==='nuevo'?'Nuevo recurso':'Editar recurso'}</h2>
                <p>{modal==='nuevo'?'Completa los datos del recurso':`Editando: ${selected?.titulo}`}</p>
              </div>
              <button className="ar-modal__close" onClick={cerrar}><IconClose/></button>
            </div>
            <div className="ar-modal__body">
              <div className="ar-form-grid">

                {/* Título */}
                <div className="ar-field ar-field--full">
                  <label>Título <span className="ar-req">*</span></label>
                  <input type="text" className="ar-input" placeholder="Ej: Guía de evaluación del lenguaje"
                    value={form.titulo} onChange={e=>setF('titulo',e.target.value)}/>
                </div>

                {/* Tipo / Categoría */}
                <div className="ar-field">
                  <label>Tipo</label>
                  <select className="ar-input ar-sel" value={form.tipo} onChange={e=>setF('tipo',e.target.value)}>
                    {TIPOS.map(t=><option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
                  </select>
                </div>
                <div className="ar-field">
                  <label>Categoría</label>
                  <select className="ar-input ar-sel" value={form.categoria} onChange={e=>setF('categoria',e.target.value)}>
                    {CATEGORIAS.map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>

                {/* Precio / Precio anterior */}
                <div className="ar-field">
                  <label>Precio (S/.) <span className="ar-req">*</span></label>
                  <input type="number" step="0.01" className="ar-input" placeholder="0.00"
                    value={form.precio} onChange={e=>setF('precio',e.target.value)}/>
                </div>
                <div className="ar-field">
                  <label>Precio anterior <span className="ar-hint">opcional — se muestra tachado</span></label>
                  <input type="number" step="0.01" className="ar-input" placeholder="0.00"
                    value={form.precio_antes} onChange={e=>setF('precio_antes',e.target.value)}/>
                </div>

                {/* Formato / Páginas / Nivel / Color */}
                <div className="ar-field">
                  <label>Formato</label>
                  <select className="ar-input ar-sel" value={form.formato} onChange={e=>setF('formato',e.target.value)}>
                    {FORMATOS.map(f=><option key={f}>{f}</option>)}
                  </select>
                </div>
                <div className="ar-field">
                  <label>Páginas / cantidad</label>
                  <input type="number" className="ar-input" placeholder="0"
                    value={form.paginas} onChange={e=>setF('paginas',e.target.value)}/>
                </div>
                <div className="ar-field">
                  <label>Nivel</label>
                  <select className="ar-input ar-sel" value={form.nivel} onChange={e=>setF('nivel',e.target.value)}>
                    {NIVELES.map(n=><option key={n}>{n}</option>)}
                  </select>
                </div>
                <div className="ar-field">
                  <label>Color de tarjeta</label>
                  <select className="ar-input ar-sel" value={form.color} onChange={e=>setF('color',e.target.value)}>
                    {COLORES.map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>

                {/* Badge / Estado */}
            {/* Imagen de portada */}
            <div className="ar-field ar-field--full">
                  <label>Imagen de portada</label>
                  <div className="ar-imagen-wrap">
                    {form.imagen_url ? (
                      <div className="ar-imagen-preview">
                        <img src={form.imagen_url} alt="Portada" className="ar-imagen-preview__img"/>
                        <div className="ar-imagen-preview__actions">
                          <button type="button" className="ar-btn-ghost ar-btn-ghost--sm"
                            onClick={() => imgRef.current?.click()} disabled={subiendoImg}>
                            {subiendoImg ? 'Subiendo…' : '🔄 Cambiar imagen'}
                          </button>
                          <button type="button" className="ar-btn-ghost ar-btn-ghost--sm"
                            style={{color:'#dc2626'}}
                            onClick={() => setF('imagen_url', '')}>
                            🗑 Quitar
                          </button>
                        </div>
                      </div>
                    ) : (
                      <button type="button"
                        className={`ar-upload-btn ${subiendoImg?'ar-upload-btn--loading':''}`}
                        onClick={() => imgRef.current?.click()}
                        disabled={subiendoImg}
                      >
                        {subiendoImg
                          ? <><span className="ar-spinner"/> Subiendo imagen…</>
                          : <><IconUpload/> Subir imagen de portada</>
                        }
                      </button>
                    )}
                    <input ref={imgRef} type="file" style={{display:'none'}}
                      accept=".jpg,.jpeg,.png,.webp"
                      onChange={subirImagen} disabled={subiendoImg}/>
                    <p className="ar-upload-hint">JPG, PNG o WEBP · Máx. 10MB · Recomendado: 800×500px</p>
                  </div>
                </div>

                {/* Badge / Estado */}
                
                <div className="ar-field">
                  <label>Badge <span className="ar-hint">Ej: Nuevo, Más vendido</span></label>
                  <input type="text" className="ar-input" placeholder="Ej: Más vendido"
                    value={form.badge} onChange={e=>setF('badge',e.target.value)}/>
                </div>
                <div className="ar-field">
                  <label>Código SUNAT <span className="ar-hint">código de catálogo de producto</span></label>
                  <input type="text" className="ar-input" placeholder="Ej: 55121644"
                    value={form.codigo_sunat||''} onChange={e=>setF('codigo_sunat',e.target.value)}/>
                </div>

               
                <div className="ar-field">
                  <label>Estado</label>
                  <select className="ar-input ar-sel" value={form.activo?'activo':'inactivo'} onChange={e=>setF('activo',e.target.value==='activo')}>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>

                {/* ══ FICHA DEL PRODUCTO ══ */}
                          {/* ══ ENTREGA Y STOCK ══ */}
                          <div className="ar-field ar-field--full">
                  <div className="ar-acceso-section">
                    <p className="ar-acceso-section__label">📦 Entrega</p>
                    <label className="ar-check-label" style={{marginTop:'.5rem'}}>
                      <input type="checkbox" checked={!!form.es_fisico}
                        onChange={e=>setF('es_fisico', e.target.checked)}/>
                      <span>Es un producto físico — se envía por courier</span>
                    </label>
                    <p className="ar-acceso-section__hint" style={{marginTop:'.4rem'}}>
                      Si lo marcas, el carrito le pedirá al cliente sus datos de entrega y se
                      descontará del stock. Déjalo sin marcar para material digital.
                    </p>

                    {form.es_fisico && (
                      <div className="ar-form-grid" style={{marginTop:'.9rem'}}>
                        <div className="ar-field">
                          <label>Unidades disponibles <span className="ar-hint">stock</span></label>
                          <input type="number" min="0" className="ar-input" placeholder="Ej: 12"
                            value={form.stock} onChange={e=>setF('stock', e.target.value)}/>
                          <span style={{fontSize:'.72rem',color:'#5a6a63',marginTop:'.3rem',display:'block'}}>
                            Al llegar a 0 el producto se muestra como “Agotado” y no se puede comprar.
                          </span>
                        </div>
                        <div className="ar-field">
                          <label>Plazo de entrega <span className="ar-hint">se muestra al cliente</span></label>
                          <input type="text" className="ar-input" placeholder="Ej: 3 a 5 días hábiles"
                            value={form.dias_entrega} onChange={e=>setF('dias_entrega', e.target.value)}/>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* ══ FICHA DEL PRODUCTO ══ */}
                <div className="ar-field ar-field--full">
                  <div className="ar-acceso-section">
                    <p className="ar-acceso-section__label">📋 Ficha del producto</p>




                    <p className="ar-acceso-section__hint">Datos que se muestran junto al precio en la página del producto. Deja vacío lo que no aplique.</p>

                    <div className="ar-form-grid" style={{marginTop:'.8rem'}}>
                      <div className="ar-field">
                        <label>Código del producto <span className="ar-hint">visible al cliente</span></label>
                        <input type="text" className="ar-input" placeholder="Ej: Rep 202601"
                          value={form.codigo||''} onChange={e=>setF('codigo',e.target.value)}/>
                      </div>
                      <div className="ar-field">
                        <label>Edad mínima <span className="ar-hint">años</span></label>
                        <input type="number" min="0" className="ar-input" placeholder="Ej: 5"
                          value={form.edad_minima} onChange={e=>setF('edad_minima',e.target.value)}/>
                      </div>
                      <div className="ar-field">
                        <label>Jugadores — mínimo</label>
                        <input type="number" min="1" className="ar-input" placeholder="Ej: 2"
                          value={form.jugadores_min} onChange={e=>setF('jugadores_min',e.target.value)}/>
                      </div>
                      <div className="ar-field">
                        <label>Jugadores — máximo</label>
                        <input type="number" min="1" className="ar-input" placeholder="Ej: 6"
                          value={form.jugadores_max} onChange={e=>setF('jugadores_max',e.target.value)}/>
                      </div>
                      <div className="ar-field">
                        <label>Duración — desde <span className="ar-hint">minutos</span></label>
                        <input type="number" min="1" className="ar-input" placeholder="Ej: 5"
                          value={form.duracion_min} onChange={e=>setF('duracion_min',e.target.value)}/>
                      </div>
                      <div className="ar-field">
                        <label>Duración — hasta <span className="ar-hint">minutos</span></label>
                        <input type="number" min="1" className="ar-input" placeholder="Ej: 15"
                          value={form.duracion_max} onChange={e=>setF('duracion_max',e.target.value)}/>
                      </div>
                    </div>

                    <div className="ar-field" style={{marginTop:'1rem'}}>
                      <label>Video de presentación <span className="ar-hint">YouTube</span></label>
                      <input type="url" className="ar-input" placeholder="https://www.youtube.com/watch?v=..."
                        value={form.video_url||''} onChange={e=>setF('video_url',e.target.value)}/>
                      {form.video_url && (() => {
                        const m = form.video_url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
                        return m ? (
                          <img src={`https://img.youtube.com/vi/${m[1]}/mqdefault.jpg`} alt="Preview"
                            style={{marginTop:'.5rem',height:80,borderRadius:8,border:'1.5px solid rgba(130,216,179,.3)'}}/>
                        ) : (
                          <p style={{fontSize:'.72rem',color:'#dc2626',marginTop:'.4rem'}}>
                            ⚠️ No se reconoce como una URL de YouTube
                          </p>
                        );
                      })()}
                    </div>
                  </div>
                </div>


                {/* Destacado */}
                <div className="ar-field ar-field--full ar-field--check">
                  <label className="ar-check-label">
                    <input type="checkbox" checked={!!form.destacado} onChange={e=>setF('destacado',e.target.checked)}/>
                    <span>⭐ Mostrar como destacado en portada</span>
                  </label>
                </div>

                {/* Descripción */}
                {/* Sección especial */}
               {/* <div className="ar-field">
                  <label>Sección especial</label>
                  <select className="ar-input ar-sel" value={form.seccion||'normal'} onChange={e=>setF('seccion',e.target.value)}>
                    <option value="normal">Normal (catálogo)</option>
                    <option value="proximos">📅 Próximos cursos</option>
                    <option value="en_vivo">🔴 Cursos en vivo</option>
                  </select>
                </div>
                {(form.seccion === 'proximos' || form.seccion === 'en_vivo') && (
                  <div className="ar-field">
                    <label>Fecha del evento <span className="ar-hint">se muestra en la sección</span></label>
                    <input type="date" className="ar-input"
                      value={form.fecha_evento||''} onChange={e=>setF('fecha_evento',e.target.value)}/>
                  </div>
                )}*/}

                {/* Descripción */}
                <div className="ar-field ar-field--full">
                  <label>Descripción corta</label>
                  <textarea className="ar-input ar-textarea" rows={2} placeholder="Breve descripción para las cards del catálogo…"
                    value={form.descripcion} onChange={e=>setF('descripcion',e.target.value)}/>
                </div>

                {/* Descripción larga */}
                <div className="ar-field ar-field--full">
                  <label>Descripción larga <span className="ar-hint">opcional — se muestra en el modal de compra</span></label>
                  <textarea className="ar-input ar-textarea" rows={3} placeholder="Descripción completa del recurso…"
                    value={form.descripcion_larga||''} onChange={e=>setF('descripcion_larga',e.target.value)}/>
                </div>

                {/* Tags */}
                <div className="ar-field ar-field--full">
                  <label>Etiquetas <span className="ar-hint">separadas por coma</span></label>
                  <input type="text" className="ar-input" placeholder="evaluación, lenguaje, protocolo"
                    value={typeof form.tags==='string'?form.tags:(form.tags||[]).join(', ')}
                    onChange={e=>setF('tags',e.target.value)}/>
                </div>

                {/* ══ SECCIÓN ACCESO AL RECURSO ══ */}
              {/* ══ SECCIÓN ACCESO AL RECURSO ══ */}
              <div className="ar-field ar-field--full">
                  <div className="ar-acceso-section">
                    <p className="ar-acceso-section__label">📦 Archivos del recurso</p>
                    <p className="ar-acceso-section__hint">Sube uno o varios archivos. El cliente accederá a todos tras pagar.</p>

                    {/* Lista de archivos subidos */}
                    {(form.archivos||[]).length > 0 && (
                      <div className="ar-archivos-lista">
                        {(form.archivos||[]).map((a, idx) => (
                          <div key={a.id||idx} className="ar-archivo-item">
                            <div className="ar-archivo-item__info">
                              <IconFile/>
                              <div>
                                <strong>{a.nombre}</strong>
                                <span>{a.tamano_kb ? `${a.tamano_kb} KB` : ''}</span>
                              </div>
                            </div>
                            <div className="ar-archivo-item__actions">
                              <a href={a.url} target="_blank" rel="noopener noreferrer" className="ar-archivo-item__ver">Ver ↗</a>
                              <button type="button" className="ar-archivo-item__del"
                                onClick={async () => {
                                  if (!window.confirm('¿Eliminar este archivo?')) return;
                                  try {
                                    const r = await fetch(`${API}?action=eliminar_archivo`, {
                                      method:'POST', headers:{'Content-Type':'application/json'},
                                      body: JSON.stringify({ id: a.id }),
                                    });
                                    const j = await r.json();
                                    if (!j.success) throw new Error(j.message);
                                    setF('archivos', (form.archivos||[]).filter((_,i) => i !== idx));
                                    showToast('Archivo eliminado');
                                  } catch(e) { showToast(e.message,'error'); }
                                }}
                              >
                                <IconTrash/>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Botón subir nuevo archivo */}
                    <button type="button"
                      className={`ar-upload-btn ${subiendo?'ar-upload-btn--loading':''}`}
                      onClick={() => {
                        if (!form.id) { showToast('Guarda el recurso primero antes de subir archivos','error'); return; }
                        fileRef.current?.click();
                      }}
                      disabled={subiendo}
                    >
                      {subiendo ? (
                        <><span className="ar-spinner"/><span>Subiendo… {progresoSub}%</span></>
                      ) : (
                        <><IconUpload/> {(form.archivos||[]).length > 0 ? 'Agregar otro archivo' : 'Subir archivo'}</>
                      )}
                    </button>
                    <input ref={fileRef} type="file" style={{display:'none'}}
                      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip,.rar,.mp4"
                      onChange={subirArchivo} disabled={subiendo}/>
                    <p className="ar-upload-hint">PDF, Word, PPT, Excel, ZIP, MP4 · Máx. 100MB por archivo</p>

                    {/* Link externo */}
                    <div className="ar-field" style={{marginTop:'1rem'}}>
                      <label>O usa un link externo <span className="ar-hint">Google Drive, Dropbox…</span></label>
                      <input type="url" className="ar-input" placeholder="https://drive.google.com/…"
                        value={form.link_externo||''} onChange={e=>setF('link_externo',e.target.value)}/>
                    </div>
                  </div>
                </div>










             

{/* ══ IMÁGENES MOCKUP ══ */}
<div className="ar-field ar-field--full">
  <div className="ar-acceso-section">
    <p className="ar-acceso-section__label">🖼️ Imágenes de vista previa (mockups)</p>
    <p className="ar-acceso-section__hint">Se muestran en el detalle del producto antes de comprar. Sube fotos del material impreso, páginas de muestra, etc.</p>

    {(form.imagenes||[]).length > 0 && (
      <div className="ar-mockups-grid">
        {(form.imagenes||[]).map((img, idx) => (
          <div key={img.id||idx} className="ar-mockup-item">
            <img src={img.url} alt={`Mockup ${idx+1}`} className="ar-mockup-item__img"/>
            <button type="button" className="ar-mockup-item__del"
              onClick={async () => {
                if (!window.confirm('¿Eliminar esta imagen?')) return;
                try {
                  const r = await fetch(`${API}?action=eliminar_imagen_mockup`, {
                    method:'POST', headers:{'Content-Type':'application/json'},
                    body: JSON.stringify({ id: img.id }),
                  });
                  const j = await r.json();
                  if (!j.success) throw new Error(j.message);
                  setF('imagenes', (form.imagenes||[]).filter((_,i) => i !== idx));
                  showToast('Imagen eliminada');
                } catch(e) { showToast(e.message,'error'); }
              }}
            >✕</button>
          </div>
        ))}
      </div>
    )}

    <button type="button"
      className={`ar-upload-btn ${subiendoMockup?'ar-upload-btn--loading':''}`}
      onClick={() => {
        if (!form.id) { showToast('Guarda el recurso primero','error'); return; }
        imgMockupRef.current?.click();
      }}
      disabled={subiendoMockup}
    >
      {subiendoMockup
        ? <><span className="ar-spinner"/> Subiendo…</>
        : <><IconUpload/> {(form.imagenes||[]).length > 0 ? 'Agregar otra imagen' : 'Subir imagen de muestra'}</>
      }
    </button>
    <input ref={imgMockupRef} type="file" style={{display:'none'}}
      accept=".jpg,.jpeg,.png,.webp"
      onChange={subirMockup} disabled={subiendoMockup}/>
    <p className="ar-upload-hint">JPG, PNG o WEBP · Máx. 10MB · Muestra páginas, contenido impreso, etc.</p>
  </div>
</div>

</div>
</div>
<div className="ar-modal__foot">
<button className="ar-btn-ghost" onClick={cerrar} disabled={guardando}>Cancelar</button>


              <button className="ar-btn-primary" onClick={guardar} disabled={guardando||subiendo}>
                {guardando?<span className="ar-spinner"/>:modal==='nuevo'?'Crear recurso':'Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════════════
          MODAL VER (detalle completo)
      ════════════════════════════════ */}
      {modal==='ver' && selected && (
        <div className="ar-overlay" onClick={cerrar}>
          <div className="ar-modal ar-modal--ver" onClick={e=>e.stopPropagation()}>
            <div className="ar-modal__head">
              <div><h2>Detalle del recurso</h2><p>Vista completa</p></div>
              <button className="ar-modal__close" onClick={cerrar}><IconClose/></button>
            </div>
            <div className="ar-modal__body">
              <div className={`ar-ver-thumb ar-thumb--${selected.color||'verde'}`}>
                <div className="ar-ver-thumb__icon">{TIPO_ICON[selected.tipo]}</div>
                <div className="ar-ver-thumb__chips">
                  {selected.badge && <span className="ar-card__badge-top">{selected.badge}</span>}
                  {selected.destacado && <span className="ar-card__dest"><IconStar/>Destacado</span>}
                </div>
              </div>
              <div className="ar-ver-info">
                <div className="ar-ver-badges">
                  <span className={`ar-badge ar-badge--cat ar-badge--${CAT_COLOR[selected.categoria]||'verde'}`}>{selected.categoria}</span>
                  <span className={`ar-badge ar-badge--tipo ar-badge--${selected.tipo}`}>{TIPO_LABEL[selected.tipo]}</span>
                  <span className={`ar-estado ar-estado--${selected.activo?'activo':'inactivo'}`}>{selected.activo?'Activo':'Inactivo'}</span>
                </div>
                <h3>{selected.titulo}</h3>
                <p className="ar-ver-desc">{selected.descripcion}</p>
                {selected.descripcion_larga && (
                  <p className="ar-ver-desc" style={{marginTop:'.5rem',color:'#5a6a63',fontSize:'.82rem'}}>{selected.descripcion_larga}</p>
                )}
                <div className="ar-ver-meta">
                  <div className="ar-ver-meta-item"><IconFile/><span>{selected.formato}</span></div>
                  {selected.paginas && <div className="ar-ver-meta-item"><IconTag/><span>{selected.paginas} páginas</span></div>}
                  <div className="ar-ver-meta-item"><IconCart/><span>{selected.ventas||0} ventas</span></div>
                  <div className="ar-ver-meta-item"><IconDollar/>
                    <span>S/. {parseFloat(selected.precio||0).toFixed(2)}
                      {selected.precio_antes && <s style={{marginLeft:'.4rem',color:'#9ca3af'}}>S/. {parseFloat(selected.precio_antes).toFixed(2)}</s>}
                    </span>
                  </div>
                </div>

                {/* Acceso */}
                <div className="ar-ver-acceso">
                  <p className="ar-ver-tags__label">Tipo de acceso</p>
                  {selected.tipo_acceso==='archivo' && selected.archivo_url ? (
                    <a href={selected.archivo_url} target="_blank" rel="noopener noreferrer" className="ar-ver-acceso__link">
                      <IconFile/> {selected.archivo_nombre||'Ver archivo'} ↗
                    </a>
                  ) : selected.tipo_acceso==='link_externo' && selected.link_externo ? (
                    <a href={selected.link_externo} target="_blank" rel="noopener noreferrer" className="ar-ver-acceso__link">
                      <IconLink/> Link externo configurado ↗
                    </a>
                  ) : (
                    <span style={{color:'#e53e3e',fontSize:'.8rem'}}>⚠️ Sin archivo ni link configurado</span>
                  )}
                </div>

                {/* Tags */}
                {selected.tags?.length>0 && (
                  <div className="ar-ver-tags">
                    <p className="ar-ver-tags__label">Etiquetas</p>
                    <div className="ar-ver-tags__list">
                      {(Array.isArray(selected.tags)?selected.tags:selected.tags?.split?.(',')||[]).map(t=>(
                        <span key={t} className="ar-ver-tag"><IconTag/>{t.trim()}</span>
                      ))}
                    </div>
                  </div>
                )}

                <div className="ar-ver-ingresos">
                  <div><span>Ingreso estimado</span><strong>S/. {((selected.ventas||0)*(selected.precio||0)).toLocaleString()}</strong></div>
                  <div><span>Nivel</span><strong>{selected.nivel}</strong></div>
                </div>
              </div>
            </div>
            <div className="ar-modal__foot">
              <button className="ar-btn-ghost" onClick={cerrar}>Cerrar</button>
              <button className="ar-btn-primary" onClick={()=>{cerrar();setTimeout(()=>abrirEditar(selected),50);}}>
                <IconEdit/> Editar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════════════
          MODAL BORRAR
      ════════════════════════════════ */}
      {modal==='borrar' && selected && (
        <div className="ar-overlay" onClick={cerrar}>
          <div className="ar-modal ar-modal--confirm" onClick={e=>e.stopPropagation()}>
            <div className="ar-modal__head">
              <div><h2>Eliminar recurso</h2><p>Esta acción no se puede deshacer</p></div>
              <button className="ar-modal__close" onClick={cerrar}><IconClose/></button>
            </div>
            <div className="ar-modal__body ar-modal__body--center">
              <div className="ar-confirm-icon"><IconTrash/></div>
              <p className="ar-confirm-texto">¿Eliminar <strong>"{selected.titulo}"</strong>? Todos los datos se perderán permanentemente.</p>
            </div>
            <div className="ar-modal__foot">
              <button className="ar-btn-ghost" onClick={cerrar} disabled={guardando}>Cancelar</button>
              <button className="ar-btn-danger" onClick={borrar} disabled={guardando}>
                {guardando?<span className="ar-spinner ar-spinner--dark"/>:<><IconTrash/> Eliminar</>}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}